import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../lib/PropTypes';

const UserContext = React.createContext(null);

export const useUserContext = () => useContext(UserContext);

export const useUser = () => {
    const { user } = useUserContext();
    return user || null;
};

const propTypes = {
    user: AppPropTypes.user,
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    user: {},
};

export const UserProvider = ({ user: initialUser, children }) => {
    const [user, setUser] = useState(initialUser);
    return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
};

UserProvider.propTypes = propTypes;
UserProvider.defaultProps = defaultProps;

export default UserContext;
